<div class="wrapper">
  <evtc-navigation-bar *ngIf="login"></evtc-navigation-bar>
  <evtc-side-menu *ngIf="login"></evtc-side-menu>
  <router-outlet></router-outlet>
  <evtc-foot *ngIf="login"></evtc-foot>
</div>